export default __webpack_public_path__ + "static/media/AT001.4db2c840.mp3";